import { ArrowRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { trackCTA } from '../../../utils/metaPixel';

import { HorizontalStepFlow, MobileStepperFlow, useDemoSteps } from './homeDemoStepperFlow';

interface HomeHowItWorksStepperSectionProps {
  onNavigate?: (view: string) => void;
}

const HomeHowItWorksStepperSection: React.FC<HomeHowItWorksStepperSectionProps> = ({ onNavigate }) => {
  const { t } = useTranslation();
  const steps = useDemoSteps(t);
  const signupLabel = t('home.hero.ctaTryFree', 'Try Free - No Signup');

  const handleSignup = () => {
    trackCTA('home_how_it_works_signup');
    onNavigate?.('signup');
  };

  return (
    <section
      id="how-it-works"
      className="home-demo-video-section home-hiw-stepper-section scroll-mt-28 font-sans"
      aria-labelledby="home-how-it-works-title"
    >
      <div className="text-center px-4 mb-6 sm:mb-10">
        <p className="hiw__eyebrow mb-2">{t('home.howItWorksFlow.eyebrow', 'End-to-end AI job search')}</p>
        <h2 id="home-how-it-works-title" className="hiw__title text-balance">
          {t('home.howItWorks', 'How it works')}
        </h2>
        <p className="hiw__subtitle text-balance max-w-2xl mx-auto mt-3">
          {t(
            'home.demoSteps.sectionSubtitle',
            'From resume upload to interview prep — AI assists at every step; you review and submit applications.',
          )}
        </p>
      </div>

      <div className="block sm:hidden">
        <MobileStepperFlow steps={steps} onSignup={handleSignup} signupLabel={signupLabel} showCta={false} />
      </div>

      <div className="hidden sm:block">
        <HorizontalStepFlow steps={steps} />
      </div>

      <div className="mt-8 flex justify-center px-4 pb-2">
        <button
          type="button"
          className="home-marketing-cta group min-h-[44px] touch-manipulation font-sans"
          onClick={handleSignup}
        >
          {signupLabel}
          <ArrowRight
            className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5"
            aria-hidden
          />
        </button>
      </div>
    </section>
  );
};

export default HomeHowItWorksStepperSection;
